import "./App.css";
import React, {useState} from 'react';
import RoutingPage from "./RoutingPage";
import { AppContext } from "./context.js";

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


function App() {
  const [fieldName, setFieldName] = useState({name:'thi is name'});
  const [videoData,setVideoData]=useState([])
  const [data, setData]=useState([])


  return (
    <>
      <div className="App">
        <ToastContainer />
        <AppContext.Provider value={{ fieldName,setFieldName,videoData,setVideoData, data, setData}}>
          <RoutingPage />
        </AppContext.Provider>
      </div>
    </>
  );
}

export default App;
